import * as React from 'react';

import Loader from 'bundles/degree-home/components/Loader';
import SummaryCourseItem from 'bundles/degree-home/components/SummaryCourseItem';
import type { NormalizedInProgressCourse } from 'bundles/degree-home/components/v2/types/courseStates';

import _t from 'i18n!nls/degree-home';

import { SummaryCard } from './SummaryCard';

type Props = {
  loading: boolean;
  inProgressCourses?: Array<NormalizedInProgressCourse>;
};

export const InProgressCourses = ({ loading, inProgressCourses }: Props) => (
  <SummaryCard title={_t('In progress')} data-e2e="in-progress-courses" data-testid="in-progress-courses">
    {loading && <Loader />}
    {!loading &&
      inProgressCourses?.map((inProgressCourse) => {
        const isCourseEnrollable = inProgressCourse.hasEnrollableSession && !inProgressCourse.activeSessionId;

        return (
          <SummaryCourseItem
            key={inProgressCourse.id}
            courseId={inProgressCourse.id}
            courseName={inProgressCourse.name}
            courseSlug={inProgressCourse.slug}
            statusText={_t('In progress')}
            isCourseEnrollable={isCourseEnrollable}
          />
        );
      })}
  </SummaryCard>
);

export default InProgressCourses;
